import {
  LocationResultsListsV2SM,
  LocationResultsListsV2XS,
} from './variations';

export const LocationResultsListsV2 = {
  XS: LocationResultsListsV2XS,
  SM: LocationResultsListsV2SM,
};
